module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scrollbar-size/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 1765
// module chunks = 0